import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index/index'
import NotFound from '@/pages/index/nofound'
import trainIndex from '@/pages/train/index'
import trainDetail from '@/pages/train/detail'
import onlineIndex from '@/pages/online/index'
import onlineDetail from '@/pages/online/detail'
import mallIndex from '@/pages/mall/index'
import mallDetail from '@/pages/mall/detail'
import aboutIndex from '@/pages/about/index'
// import Webview from '@/pages/index/webview'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
        path: '/train/index',
        name: 'trainIndex',
        component: trainIndex,
    },{
          path: '/train/detail',
          name: 'trainDetail',
          component: trainDetail,
      },{
        path: '/online/index',
        name: 'onlineIndex',
        component: onlineIndex,
    },{
        path: '/online/detail',
        name: 'onlineDetail',
        component: onlineDetail,
    },{
        path: '/mall/index',
        name: 'mallIndex',
        component: mallIndex,
    },{
        path: '/mall/detail',
        name: 'mallDetail',
        component: mallDetail,
    },{
          path: '/about/index',
          name: 'aboutIndex',
          component: aboutIndex,
      },

    { path: '*', component: NotFound }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js